
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuTamawaraiMenuTamawaraiMenuTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/tamawarai_menu",
  title: "【ミシュランのお店】玉笑のおすすめメニューを一挙公開",
  description: "原宿で長年人気の蕎麦のお店「玉笑」のおすすめのメニューを写真付きでご紹介します。定番のせいろから、玉笑独自のメニュー、そして人気のかけそばまで幅広くご紹介します。また、行列ができるお店なので、行列に関する情報も併せてご紹介。気になるメニューをチェックして、行列に巻き込まれないような時間帯でお越しください。",
  topImg: harajukuTamawaraiMenuTamawaraiMenuTopImage,
  author: murakamiMasanori,
  tags: ["駅近", "原宿", "そば", "人気店", "お店の紹介", "メニュー詳細", "ミシュラン掲載"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で長年人気の蕎麦のお店「玉笑」のおすすめのメニューを写真付きでご紹介します。`}</p>
    <p>{`定番のせいろは独特の麺の作り方をしており、香り豊かな麺が楽しめるそう。`}</p>
    <p>{`また、冬に食べたくなるメニュ、ここでしか食べられない大粒の納豆を使ったメニューなど、盛り沢山。行列ができるお店なので、行列に関する情報も今回は特別にご紹介。`}</p>
    <p>{`気になるメニューをチェックしてみてください！`}</p>
    <h2>{`玉笑のメニュー`}</h2>
    <InstaImage postId="CB-ysu6Hegu" mdxType="InstaImage" />
    <p>{`ミシュランに選ばれるほど世界的にも有名なお店で、日本では 1 番を争うほどの名店「玉笑」。特別な素材で作る自家製の蕎麦の食感や、メニューごとに違った蕎麦の風味を楽しめることが話題となっており、連日行列ができる名店です。`}</p>
    <p>{`そんな玉笑のおすすめのメニューについて、本日はご紹介させていただきます。`}</p>
    <h3>{`粗挽きせいろ`}</h3>
    <InstaImage postId="CB-nj7yAF8M" mdxType="InstaImage" />
    <p>{`玉笑で 1 番定番のおすすめランチが粗挽きせいろそば。
初めて玉笑にお越しの方には、1 番最初におすすめしたいメニューです。
名前の通り`}<strong parentName="p">{`本来の味と風味を感じてもらうために粗挽き`}</strong>{`にしており、蕎麦から驚くほどの香りや甘みが感じられます。`}</p>
    <p>{`ざらっとした食感のある蕎麦は、濃い味のつゆと一緒に食べると、蕎麦の旨味が引出される一品です。`}</p>
    <h3>{`納豆そば`}</h3>
    <InstaImage postId="B-BKTObAvOS" mdxType="InstaImage" />
    <p>{`近年せいろ蕎麦と並んで人気が高まっているのが、こちらの納豆そば。
かつおぶし、玉子、ねぎ、のりが入ったメニューで、特に青大豆使用の納豆は、大粒で普段とは違った納豆の風味と食感を体験できます。`}</p>
    <p>{`そばの甘味と納豆をはじめとした食材がバランスよく交わり合い、独特の旨味を引き出す一品で、箸が止まらなくなります。`}</p>
    <h3>{`豆腐そば`}</h3>
    <InstaImage postId="CCN7u4yM9nQ" mdxType="InstaImage" />
    <p>{`昼夜問わず人気の高い手作りの豆腐に、甘みと香りのあるそばを一緒に堪能できるおすすめのメニュー。
手作り豆腐はサラッとした舌触りで、蕎麦と同じくらい風味と甘みがあって、しっかりとした味わいになっています。`}</p>
    <p>{`体にも優しい健康的なメニューなので、健康志向の方は食べておきたい一品です。`}</p>
    <h3>{`卵とじそば`}</h3>
    <InstaImage postId="Bw4YXd6nSFY" mdxType="InstaImage" />
    <p>{`鰹の効いた優しい出汁が、多くのお客様の心を掴んでいるおすすめの一品。サラサラッと食べやすく、そばの味もしっかり堪能できる一品。冬の寒い日や体を少し労わりたい日には、卵とじそばがオススメです！`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <InstaImage postId="CBqGpQxjYO5" mdxType="InstaImage" />
    <InstaImage postId="Bt-M6i7HWJh" mdxType="InstaImage" />
    <p>{`ミシュランにも選出される人気店なので、普段からランチの時間帯は行列ができていることが多いです。売り切れ次第終了のお店なので、せっかくランチを楽しみに食べに行ったのに、食べれなかったという体験をしてしまうのは悲しいと思います。`}</p>
    <p>{`開店時間頃から行列ができるので、お店にお越しの際には 11:30~12:00 までにはお店に到着しておくことをおすすめします。
原宿は人が多く道も混むことが多いので、余裕を持って行ってください！`}</p>
    <h3>{`おわりに`}</h3>
    <p>{`原宿の蕎麦のおすすめのお店「玉笑」の人気のメニューと行列情報についてご紹介してきましたが、いかがでしたでしょうか。蕎麦の中でも、種類が豊富にあるのが特徴的で、気になったメニューがあれば、お店に行く前にチェックしていただくことをおすすめします！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;